import Config from '@/config'

const langs = {
  'zh-CN': ['zh-cn', 'cn', 'zh'],
  'ja-JP': ['ja-jp', 'ja', 'jp'],
  'en-US': ['en-us', 'en', 'us']
}

const langKeys = Object.keys(langs)

let currentLang = langKeys[0]

/**
 *
 * @description 根据语言标识获取对应的语言类型
 * @param {*} [lang=langKeys[0]]
 * @returns
 */
function getLangType (lang = langKeys[0]) {
  if (langs[lang]) return lang
  for (const i in langs) {
    if (langs[i].indexOf(lang.toLowerCase()) !== -1) {
      return i
    }
  }
  return langKeys[2] // 没有中英日，默认英文
}

/**
 *
 * @description 获取浏览器主语言
 * @returns
 */
function getMobileLang () {
  if (process.env.NODE_ENV === 'development') {
    return Config.default_language
  } else {
    let language = window.navigator.language
    return language || 'zh-CN'
  }
}

/**
 * 初始化浏览器语言
 */
export function initLang () {
  const mobileLang = getMobileLang()
  const langType = getLangType(mobileLang)
  currentLang = langType
  return langType
}

/**
 *
 * @description 获取当前主语言
 * @export
 * @returns
 */
export function getLang () {
  return currentLang
}
